<template>
    <v-snackbar top v-model="snack" :timeout="par.timeOut" :color="par.color" class="snackbar-toast">

        <div class="d-flex align-center gap-2">
            <v-icon v-if="par.icona">{{ par.icona }}</v-icon>
            <span>{{ message }}</span>
        </div>

        <v-btn v-if="isUpdate" variant="text" @click="aggiorna">
            Aggiorna
            <v-icon end>mdi-refresh</v-icon>
        </v-btn>

        <template #actions>
            <v-btn v-if="par.closeButton" variant="text" rounded @click="snack = false">
                Chiudi
            </v-btn>
        </template>

    </v-snackbar>
</template>


<script>
import { ref, getCurrentInstance, onBeforeMount, onBeforeUnmount } from "vue"
import { EventBus } from "@/components/toast/toastEventBus"

export default {
    name: "ToastPlugin",

    setup() {

        const instance = getCurrentInstance()

        const snack = ref(false)
        const message = ref("")
        const isUpdate = ref(false)

        const par = ref({
            closeButton: null,
            location: null,
            timeOut: null,
            color: null,
            icona: null
        })

        // Preset per tipo
        const presets = {
            info: { color: "info", icona: "mdi-information" },
            alert: { color: "warning", icona: "mdi-alert" },
            error: { color: "error", icona: "mdi-close-circle" },
            success: { color: "success", icona: "mdi-check-circle" }
        }

        const handleToast = ({ tipo, msg, par: _par }) => {
            snack.value = !!msg

            // Merge: defaults globali → preset tipo → opzioni per-chiamata
            const globalOptions = instance.appContext.config.globalProperties.$toastOptions
            const preset = presets[tipo] ?? {}

            par.value = {
                ...globalOptions,
                ...preset,
                ..._par
            }

            if (!snack.value) return

            message.value = msg
            isUpdate.value = false

            if (tipo === "update") {
                par.value.timeOut = -1
                isUpdate.value = true
            }
        }

        const aggiorna = () => {
            localStorage.removeItem("version")
            window.location.reload()
        }

        onBeforeMount(() => {
            EventBus.on("ToastMessage", handleToast)
        })

        onBeforeUnmount(() => {
            EventBus.off("ToastMessage", handleToast)
        })

        return {
            snack,
            message,
            isUpdate,
            par,
            aggiorna
        }
    }
}
</script>
